/**
 * TODO: The boolean value is opposite to what we expect because I switched the ui around.
 * TODO: Fix it
 */
angular.module('app').directive('btnSwitch', function () {
    return {
        restrict: 'EA',
        require: 'ngModel',
        // templateUrl: 'switcher.html',
        replace: true,
        link: function (scope, element, attrs, ngModel) {
            // Specify how UI should be updated
            ngModel.$render = function () {
                render();
            };
            let render = function () {
                let val = !ngModel.$viewValue;
                let open = angular.element(element.children()[0]);
                open.removeClass(val ? 'hide' : 'show');
                open.addClass(val ? 'show' : 'hide');
                let closed = angular.element(element.children()[1]);
                closed.removeClass(val ? 'show' : 'hide');
                closed.addClass(val ? 'hide' : 'show');
            };
            // Listen for the button click event to enable binding
            element.bind('click', function () {
                scope.$apply(toggle);
            });
            // Toggle the model value
            function toggle() {
                let val = ngModel.$viewValue;
                ngModel.$setViewValue(!val);
                render();
            }
            if (!ngModel) {
                // TODO: Indicate that something is missing!
                return;
            } // do nothing if no ng-model
            // Initial render
            render();
        },
        template: `
<span class="btn boolean">
    <span class="btn btn-default btn-xs off ">Off</span>
     <span class="btn btn-info btn-xs on ">On</span>
</span>
`
    };
});
